/**
 *
 * key
 *
 */

 const key = 'YmRtUGFzc3dvcmRTZXR1cA=='

 export default key
 